const AuditDetailView = ({ audit }) => {

    const oldRows =
        Array.isArray(audit?.old_value)
            ? audit.old_value
            : [];

    const newRows =
        Array.isArray(audit?.new_value)
            ? audit.new_value
            : [];

    const isNewRecord =
        oldRows.length === 0;

    if (!newRows.length) {

        return (
            <div className="va-state va-state--empty">
                No details available
            </div>
        );
    }

    return (

        <div>

            <h4
                style={{
                    marginBottom: "20px"
                }}
            >
                {
                    isNewRecord
                        ? "Added Record"
                        : "Modified Record"
                }
            </h4>

            {
                newRows.map((row, index) => {

                    const oldRow =
                        oldRows[index] || {};

                    // Case 1:
                    // [{label,value}]
                    if (row.label) {

                        return (

                            <div
                                key={index}
                                className="va-audit-detail-card"
                            >

                                <div className="va-audit-table-header">
                                    <div>Field</div>
                                    <div>Old Value</div>
                                    <div>New Value</div>
                                </div>

                                <div className="va-audit-table-row">

                                    <div className="va-audit-field">
                                        {row.label}
                                    </div>

                                    <div className="va-audit-old">

                                        {
                                            oldRow.value
                                                ? oldRow.value
                                                : (
                                                    <span className="va-audit-first">
                                                        First Value
                                                    </span>
                                                )
                                        }

                                    </div>

                                    <div className="va-audit-new">
                                        {row.value}
                                    </div>

                                </div>

                            </div>
                        );
                    }

                    // Case 2:
                    // Table response

                    // Find a category-like field for the row heading.
                    // Schema labels are capitalized (e.g. "Category"),
                    // so a plain row.category lookup never matches —
                    // search case-insensitively instead.
                    const categoryKey = Object.keys(row).find(
                        k => k.toLowerCase() === "category"
                    );
                    const rowHeading = categoryKey
                        ? row[categoryKey]
                        : `Row ${index + 1}`;

                    return (

                        <div
                            key={index}
                            className="va-audit-detail-card"
                        >

                            <h5
                                style={{
                                    marginBottom: "15px"
                                }}
                            >
                                {rowHeading}
                            </h5>

                            <div className="va-audit-table-header">
                                <div>Field</div>
                                <div>Old Value</div>
                                <div>New Value</div>
                            </div>

                            {
                                Object.keys(row)
                                    .filter(
                                        k =>
                                            k !== categoryKey
                                    )
                                    .map(field => (

                                        <div
                                            key={field}
                                            className="va-audit-table-row"
                                        >

                                            <div className="va-audit-field">
                                                {
                                                    field
                                                        .replaceAll(
                                                            "_",
                                                            " "
                                                        )
                                                        .replace(
                                                            /\b\w/g,
                                                            c =>
                                                                c.toUpperCase()
                                                        )
                                                }
                                            </div>

                                            <div className="va-audit-old">

                                                {
                                                    oldRow[field]
                                                        ? oldRow[field]
                                                        : (
                                                            <span className="va-audit-first">
                                                                First Value
                                                            </span>
                                                        )
                                                }

                                            </div>

                                            <div className="va-audit-new">
                                                {row[field]}
                                            </div>

                                        </div>

                                    ))
                            }

                        </div>
                    );

                })
            }

        </div>
    );
};

export default AuditDetailView;